<template>
  <div class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-6">
          <MyTutors />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyTutors from "../components/Tutors/MyTutors.vue";
export default {
  components: { MyTutors }
};
</script>

<style lang="scss" scoped></style>
